import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import { Dropdown } from 'semantic-ui-react';

class Customertype extends React.Component {

  state = {
    maxWidth: 'sm', fullWidth: true,
    customerTypeOption: [], load: false, message: ''
  }

  componentDidMount() {
    this.getCustomerType();
    this.getcustomer();
  }

  componentDidUpdate(props) {
    if (props.id != this.props.id) {
      this.getCustomerType();
      this.getcustomer();
    }
  }

  getCustomerType() {
    let context = this;
    context.setState({ load: true, message: 'Getting Executive!!!' });
    let data1 = {};
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'menucontrol/getcustomertypes.php',
      success: function(data) {
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          context.setCustomerTypes(data);
        } catch (e) {
          context.setState({ load: false });
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  getcustomer() {
    let context = this;
    context.setState({ load: true, message: 'Getting Executive!!!' });
    let data1 = {'id': this.props.id};
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'offer/getcustomers.php',
      success: function(data) {
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          context.selected(data)
        } catch (e) {
          console.log(e);
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  selected(data) {
    let context = this;
    var model = [];
    data.map((y) => { model.push(y.customer_type); });
    context.setState({ type: model });
  }

  onChange = (type) => (f, { value }) => {
    if (!this.props.menuPermission.edit) {
      alert('Access is Denied!!!');
      return;
    }
    this.check(value);
    this.setState({ [type]: value })
  }

  check(value) {
    let oldValue = this.state.type;
    let length = value.length;
    if (length > oldValue.length) {
      for (var i = 0; i < length; i++) {
        if (oldValue.length == 0) {
          this.add(value[i]);
          return;
        }
        for (var j = 0; j < oldValue.length; j++) {
          if (oldValue[j] != value[i]) {
            this.add(value[i]);
            return;
          }
        }
      }
    } else if (length < oldValue.length) {
      for (var i = 0; i < oldValue.length; i++) {
        if (length == 0) {
          this.remove(oldValue[i]);
          return;
        }
        for (var j = 0; j < length; j++) {
          if (oldValue[i] != value[j]) {
            this.remove(oldValue[i]);
            return;
          }
        }
      }
    }
  }

  add(id) {
    let context = this;
    context.setState({ load: true, message: 'Adding Customer Type!!!' });
    let data1 = {'id': this.props.id, 'type': id};
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'offer/addcustomers.php',
      success: function(data) {
        context.setState({ load: false });
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
  }

  remove(id) {
    let context = this;
    context.setState({ load: true, message: 'Removing Customer Type!!!' });
    let data1 = {'id': this.props.id, 'type': id};
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'offer/removecustomers.php',
      success: function(data) {
        context.setState({ load: false });
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
  }

  setCustomerTypes(data) {
    let context = this;
    var x = [];
    data.map((y) => {
      x.push({key: y.type_name, text: y.type_name, value: y.id});
    });
    try {
      context.setState({ customerTypeOption: x });
    } catch (e) {}
  }

  handleClose = () => { this.setState({ openDialog: false }); };

  render() {
    return (
      <div style={{color: 'blue'}}>
        <Loading load={this.state.load} message={this.state.message} />
        <div onClick={ () => { this.setState({ openDialog: true }) }} style={{color: '#3E71A4', cursor: 'pointer'}}>View</div>
        <React.Fragment>
          <Dialog fullWidth={this.state.fullWidth}
            maxWidth={this.state.maxWidth}  open={this.state.openDialog}
            onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
            <DialogTitle id="max-width-dialog-title">Customer Type</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Customer Type<br/>
                <Dropdown fluid multiple id="Type" onChange={this.onChange('type')}
                  search selection options={this.state.customerTypeOption}
                  value={this.state.type} style={{ borderColor: '#5A9CBB' }} />
                </DialogContentText>
                <br/><br/><br/><br/>
            </DialogContent>
          </Dialog>
        </React.Fragment>
      </div>
    );
  }
}

export default Customertype;
